import {
  FsSetPointRules,
  isFsPositionSetPointRules,
} from "db/model/match/Set/FsSetPointRules";
import { SetPointRules } from "model/Match/Set/SetPointRules";

export const mapSetPointRules = (fsModel: FsSetPointRules): SetPointRules => {
  if (isFsPositionSetPointRules(fsModel)) {
    return {
      position: fsModel.position ?? [1, 0],
    };
  }

  return {
    win: fsModel.win ?? 1,
    draw: fsModel.draw ?? 0,
    loss: fsModel.loss ?? 0,
  };
};
